export default "__VITE_ASSET__CsdyHeOE__"